import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "./style.scss";
import TextTitle from "../../../common/ui/typography/TextTitle";
import Button from "../../../common/ui/buttons/Button";
import TextInput from "../../../common/form/TextInput";
import Icon from "../../../common/ui/Icon";
import { useMutation } from "react-query";
import { statistics } from "../../../../api/statistics";
import { useGlobalStore } from "../../../../store";

interface SetTruckLimitModalProps {
  isOpen: boolean;
  toggle: () => void;
  initialLimit: number;
  onSave: (value: number) => void;
  truckLimit: number;
}

const SetTruckLimitModal: React.FC<SetTruckLimitModalProps> = ({
  isOpen,
  toggle,
  onSave,
  truckLimit,
}) => {
  const [limit, setLimit] = useState(truckLimit);
  const selectedCompany = useGlobalStore(state => state.selectedCompany);

  const { mutate, isLoading } = useMutation({
    mutationFn: (newLimit: number) =>
      statistics.setTruckLimit(selectedCompany, newLimit),
    onSuccess: () => {
      onSave(limit);
      toggle();
    },
  });

  const increment = () => setLimit(prev => prev + 1);
  const decrement = () => setLimit(prev => (prev > 0 ? prev - 1 : 0));

  const handleChange = (val: number) => {
    if (!isNaN(val)) setLimit(val);
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className='truck-limit-modal'
    >
      <ModalHeader>
        <div className='d-flex w-100 justify-content-between align-items-center'>
          <TextTitle level='1'>Set truck limit</TextTitle>
          <Button
            size={"sm"}
            onClick={toggle}
            beforeIcon={"dismiss"}
            beforeClass='mr-0'
          />
        </div>
      </ModalHeader>
      <ModalBody>
        <div className='limit-control'>
          <TextInput
            label='Limit amount'
            type='number'
            value={limit}
            onChange={handleChange}
          />
          <div className='button-group'>
            <Button
              onClick={increment}
              className='button-left'
              beforeClass='mr-0'
              before={
                <>
                  <Icon icon='add_filled' color='#9B9DAA' size={"20px"} />
                </>
              }
            />
            <Button
              onClick={decrement}
              className='button-right'
              beforeClass='mr-0'
              before={
                <>
                  <Icon icon='minus-filled' color='#9B9DAA' size={"20px"} />
                </>
              }
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div style={{ display: "flex", width: "100%", gap: 12 }}>
          <Button onClick={toggle} className='w-100'>
            Cancel
          </Button>
          <Button
            onClick={() => mutate(limit)}
            color='blue'
            className='w-100'
            loading={isLoading}
            disabled={isLoading}
          >
            Save limit
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default SetTruckLimitModal;
